import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from 'sweetalert2';
import '../styles/styles.css';
import { resolveApiBaseList } from '../utils/apiBase';

const RegistroCalificacionesGrupo = () => {
  // ===== Estados para datos del servidor =====
  const [gruposDisponibles, setGruposDisponibles] = useState([]);
  const [docenteInfo, setDocenteInfo] = useState(null);
  const [categoriasYMaterias, setCategoriasYMaterias] = useState([]);
  const [trimestresDisponibles, setTrimestresDisponibles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [alumnos, setAlumnos] = useState([]);



  // ===== Estado de filtros =====
  const [grupo, setGrupo] = useState("");      // IdGrupo seleccionado
  const [trimestre, setTrimestre] = useState(""); // "1","2","3"
  const [fase, setFase] = useState("");        // texto "Fase N"

  const apiBases = useMemo(() => resolveApiBaseList(), []);

  const fetchJsonWithFallback = useCallback(async (path, options = {}) => {
    let lastError = null;

    for (const base of apiBases) {
      const normalizedBase = base.replace(/\/$/, '');
      const normalizedPath = path.startsWith('/') ? path : `/${path}`;
      const url = `${normalizedBase}${normalizedPath}`;

      try {
        const response = await fetch(url, options);
        const text = await response.text();

        if (!response.ok) {
          let message = text || `Error ${response.status}`;
          try {
            const parsed = text ? JSON.parse(text) : null;
            if (parsed && typeof parsed === 'object') {
              message = parsed.message || parsed.error || message;
            }
          } catch {
            // mantener mensaje original
          }

          const error = new Error(message);
          error.status = response.status;
          lastError = error;
          console.warn(`Warning: petición fallida a ${url}:`, error);
          continue;
        }

        const trimmed = text.trim();
        if (!trimmed) {
          return { data: {}, baseUrl: normalizedBase };
        }

        try {
          return { data: JSON.parse(trimmed), baseUrl: normalizedBase };
        } catch (parseErr) {
          lastError = new Error(`Respuesta inválida desde ${url}`);
          console.warn(`Warning: no se pudo parsear JSON desde ${url}`, parseErr);
        }
      } catch (error) {
        lastError = error;
        console.warn(`Warning: error de red al solicitar ${url}:`, error);
      }
    }

    throw lastError || new Error('No se pudo contactar al servidor.');
  }, [apiBases]);

  // ===== useEffect para cargar datos iniciales =====
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setLoading(true);
        const datosUsuario = obtenerDatosUsuario();
        
        if (!datosUsuario) return;

        // 1. Obtener información del docente
        const docenteParams = new URLSearchParams({ idUsuario: datosUsuario.idUsuario });
        const { data: dataDocente } = await fetchJsonWithFallback(`/calificaciones/docente-info?${docenteParams.toString()}`);
        console.log('📦 Data docente recibida:', dataDocente);
        
        if (!dataDocente.docente) {
          throw new Error('No se encontró información del docente en la respuesta');
        }
        
        setDocenteInfo(dataDocente.docente);

        // 2. Obtener grupos donde imparte clases
        const gruposParams = new URLSearchParams({ idDocente: dataDocente.docente.IdDocente });
        const { data: dataGrupos } = await fetchJsonWithFallback(`/calificaciones/mis-grupos-calificaciones?${gruposParams.toString()}`);
        setGruposDisponibles(dataGrupos.grupos);

      } catch (error) {
        console.error('Error al cargar datos iniciales:', error);
        alert('Error al cargar los datos: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    cargarDatos();
  }, []);

  // Función para obtener datos del usuario desde sessionStorage
  const obtenerDatosUsuario = () => {
    // Sistema dual de almacenamiento como en otros componentes
    const idUsuarioSession = sessionStorage.getItem('idUsuario');
    const idUsuarioLocal = localStorage.getItem('idUsuario');
    const idUsuario = idUsuarioSession || idUsuarioLocal;
    
    const displayNameSession = sessionStorage.getItem('displayName');
    const displayNameLocal = localStorage.getItem('displayName');
    const displayName = displayNameSession || displayNameLocal;
    
    console.log('🔍 Obteniendo datos del usuario:');
    console.log('  - idUsuario desde sessionStorage:', idUsuarioSession);
    console.log('  - idUsuario desde localStorage:', idUsuarioLocal);
    console.log('  - idUsuario final:', idUsuario);
    console.log('  - displayName desde sessionStorage:', displayNameSession);
    console.log('  - displayName desde localStorage:', displayNameLocal);
    console.log('  - displayName final:', displayName);
    
    // También verificar todos los datos disponibles en sessionStorage
    console.log('📋 Todos los datos en sessionStorage:');
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      console.log(`  - ${key}: ${sessionStorage.getItem(key)}`);
    }
    
    if (!idUsuario) {
      console.error('❌ No se encontró idUsuario en sessionStorage ni localStorage');
      alert('No se encontró información del usuario logueado. Por favor, inicia sesión nuevamente.');
      return null;
    }
    
    return { idUsuario, displayName };
  };









  // Cargar solo los alumnos pendientes para un trimestre específico
  const cargarAlumnosPendientes = async (grupoId, trimestre) => {
    if (!docenteInfo || !grupoId || !trimestre) {
      console.log('🔍 Faltan datos para cargar alumnos pendientes:', { docenteInfo, grupoId, trimestre });
      return;
    }

    try {
      console.log(`🔍 Cargando alumnos pendientes para Trimestre ${trimestre}`);
      
      const params = new URLSearchParams({
        idDocente: docenteInfo.IdDocente,
        grupoId,
        trimestre
      });

      const { data } = await fetchJsonWithFallback(`/calificaciones/alumnos-pendientes-trimestre?${params.toString()}`);
      if (data.success) {
        setAlumnos(data.alumnos);
        console.log(`✅ Alumnos pendientes cargados: ${data.alumnos.length}`);
        
        if (data.alumnos.length === 0) {
          alert(`✅ ¡Excelente! Todos los alumnos ya han sido calificados en el Trimestre ${trimestre}`);
        }
      } else {
        alert(data.message || 'Error al cargar alumnos pendientes');
        setAlumnos([]);
      }
    } catch (error) {
      console.error('💥 Error al cargar alumnos pendientes:', error);
      alert('Error al cargar alumnos pendientes: ' + error.message);
      setAlumnos([]);
    }
  };

  // Cargar materias que imparte el docente en el grupo seleccionado
  const cargarMateriasDocente = async (grupoId) => {
    if (!docenteInfo || !grupoId) {
      console.log('Faltan datos para cargar materias:', { docenteInfo, grupoId });
      return;
    }

    try {
      const params = new URLSearchParams({
        idDocente: docenteInfo.IdDocente,
        grupoId
      });

      const { data } = await fetchJsonWithFallback(`/calificaciones/materias-docente-grupo?${params.toString()}`);
      if (data.success) {
        setCategoriasYMaterias(data.categorias);
        console.log('Categorías y materias cargadas:', data.categorias);
      } else {
        alert(data.message || 'Error al cargar materias');
        setCategoriasYMaterias([]);
      }
    } catch (error) {
      console.error('Error al cargar materias del docente:', error);
      alert('Error al cargar materias: ' + error.message);
      setCategoriasYMaterias([]);
    }
  };

  // Cargar trimestres disponibles para el docente y grupo seleccionado
  const cargarTrimestresDisponibles = async (grupoId) => {
    console.log('🔍 DEBUG: Iniciando cargarTrimestresDisponibles con grupoId:', grupoId);
    console.log('🔍 DEBUG: docenteInfo:', docenteInfo);
    
    if (!docenteInfo || !grupoId) {
      console.log('❌ Faltan datos para cargar trimestres:', { docenteInfo, grupoId });
      return;
    }

    try {
      const params = new URLSearchParams({
        idDocente: docenteInfo.IdDocente,
        grupoId
      });

      const { data } = await fetchJsonWithFallback(`/calificaciones/trimestres-disponibles?${params.toString()}`);
      console.log('📦 DEBUG: Respuesta completa del servidor:', data);
      
      if (data.success) {
        setTrimestresDisponibles(data.trimestres);
        console.log('✅ Trimestres disponibles cargados:', data.trimestres);
        console.log('✅ Número de trimestres disponibles:', data.trimestres.length);
      } else {
        console.log('❌ Error en la respuesta del servidor:', data.message);
        alert(data.message || 'Error al cargar trimestres disponibles');
        setTrimestresDisponibles([]);
      }
    } catch (error) {
      console.error('💥 Error al cargar trimestres disponibles:', error);
      alert('Error al cargar trimestres: ' + error.message);
      setTrimestresDisponibles([]);
    }
  };

  // ===== Estado de calificaciones / asistencias por alumno =====
  // Estructura: { [alumnoIdx]: { 'leng-0': 6..10 | "", 'cien-0': ..., ... } }
  const [notas, setNotas] = useState({});
  // Asistencias, inasistencias, retardos
  const [asistData, setAsistData] = useState({}); // { [alumnoIdx]: { asist: "0", inas: "0", ret: "0" } }

  // Validar que todos los campos estén completos antes de guardar
  const validarCamposCompletos = () => {
    const errores = [];

    if (alumnos.length === 0) {
      errores.push('Debes tener al menos un alumno para calificar.');
    }

    alumnos.forEach((alumno, idx) => {
      categoriasYMaterias.forEach((categoria) => {
        categoria.materias.forEach((materia) => {
          const key = `cat-${categoria.IdCategoriaMateria}-mat-${materia.IdMateria}`;
          const nota = notas?.[idx]?.[key];
          if (nota === undefined || nota === '') {
            errores.push(`${alumno.NombreCompleto}: falta calificación en ${materia.NombreMateria}`);
          }
        });
      });

      const asist = asistData?.[idx]?.asist;
      const inas = asistData?.[idx]?.inas;
      const sugerencias = asistData?.[idx]?.sugerencias;
      const observaciones = asistData?.[idx]?.observaciones;

      if (asist === undefined || asist === '') {
        errores.push(`${alumno.NombreCompleto}: captura las asistencias`);
      }

      if (inas === undefined || inas === '') {
        errores.push(`${alumno.NombreCompleto}: captura las inasistencias`);
      }

      if (sugerencias === undefined || sugerencias.trim() === '') {
        errores.push(`${alumno.NombreCompleto}: escribe al menos una sugerencia`);
      }

      if (observaciones === undefined || observaciones.trim() === '') {
        errores.push(`${alumno.NombreCompleto}: escribe al menos una observación`);
      }
    });

    if (errores.length > 0) {
      const listaErrores = errores.slice(0, 10).map((err) => `<li>${err}</li>`).join('');
      Swal.fire({
        icon: 'warning',
        title: 'Faltan datos por capturar',
        html: `<ul style="text-align:left;">${listaErrores}</ul>` + (errores.length > 10 ? '<p>…y más registros pendientes.</p>' : ''),
        confirmButtonText: 'Entendido'
      });
      return false;
    }

    return true;
  };



  // Cambio de grupo → set Fase y cargar alumnos
  const handleGrupoChange = async (val) => {
    setGrupo(val);
    setTrimestre(''); // Limpiar trimestre seleccionado
    setAlumnos([]); // Limpiar alumnos
    
    if (val) {
      // Buscar información del grupo seleccionado
      const grupoSeleccionado = gruposDisponibles.find(g => g.IdGrupo.toString() === val);
      if (grupoSeleccionado) {
        // Determinar fase basada en el grado según el nuevo modelo educativo
        const grado = parseInt(grupoSeleccionado.Grado, 10);
        let f = "";
        if ([1, 2].includes(grado)) {
          f = "Fase 3 - Primero y Segundo de Primaria (6-9 años)";
        } else if ([3, 4].includes(grado)) {
          f = "Fase 4 - Tercero y Cuarto de Primaria (9-11 años)";
        } else if ([5, 6].includes(grado)) {
          f = "Fase 5 - Quinto y Sexto de Primaria (11-13 años)";
        }
        setFase(f);
        
        // Limpiar alumnos - se cargarán cuando se seleccione un trimestre
        setAlumnos([]);
        
        // Cargar materias que imparte el docente en este grupo
        await cargarMateriasDocente(val);
        
        // Cargar trimestres disponibles para este grupo y docente
        await cargarTrimestresDisponibles(val);
      }
    } else {
      setFase("");
      setAlumnos([]);
      setTrimestresDisponibles([]);  // Solo limpiar trimestres si NO hay grupo seleccionado
    }
    
    // Limpiar datos previos
    setNotas({});
    setAsistData({});
  };

  // Cambio de trimestre → actualizar estado y cargar alumnos pendientes
  const handleTrimestreChange = async (val) => {
    setTrimestre(val);
    // Limpiar calificaciones previas al cambiar de trimestre
    setNotas({});
    setAsistData({});
    
    // Cargar solo los alumnos que NO han sido calificados en este trimestre
    if (val && grupo) {
      await cargarAlumnosPendientes(grupo, val);
    }
  };

  // Función para manejar cambios en las calificaciones
  const handleNotaChange = (alumnoIdx, key, valor) => {
    setNotas(prev => ({
      ...prev,
      [alumnoIdx]: {
        ...prev[alumnoIdx],
        [key]: valor
      }
    }));
  };

  // Select 6–10



  // Guardar calificaciones en base de datos
  const handleGuardar = async () => {
    if (!grupo || !trimestre || !docenteInfo) {
      await Swal.fire('Atención', 'Selecciona grupo y trimestre antes de guardar', 'warning');
      return;
    }

    if (categoriasYMaterias.length === 0) {
      await Swal.fire('Atención', 'No hay materias disponibles para calificar', 'warning');
      return;
    }

    if (!validarCamposCompletos()) {
      return;
    }

    try {
      setGuardando(true);
      const payload = alumnos.map((alumno, idx) => {

        // Convertir las calificaciones del formato key-value a objeto con nombres de materias
        const materiasCalificaciones = {};
        
        categoriasYMaterias.forEach(categoria => {
          categoria.materias.forEach(materia => {
            const key = `cat-${categoria.IdCategoriaMateria}-mat-${materia.IdMateria}`;
            const nota = notas?.[idx]?.[key];
            if (nota && !isNaN(parseFloat(nota))) {
              materiasCalificaciones[materia.NombreMateria] = parseFloat(nota);
            }
          });
        });

        return {
          idAlumno: alumno.IdAlumno,
          materias: materiasCalificaciones,
          asistencias: parseInt(asistData?.[idx]?.asist || 0),
          inasistencias: parseInt(asistData?.[idx]?.inas || 0),
          sugerencias: asistData?.[idx]?.sugerencias || "",
          observaciones: asistData?.[idx]?.observaciones || "",
        };
      });

      console.log('Payload a enviar:', {
        grupoId: parseInt(grupo),
        docenteNombre: `${docenteInfo.Nombre} ${docenteInfo.ApellidoPaterno} ${docenteInfo.ApellidoMaterno}`,
        trimestre,
        fase,
        alumnos: payload
      });

      // Llamada al backend para guardar
      const { data: result } = await fetchJsonWithFallback('/calificaciones/registrar-grupo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          grupoId: parseInt(grupo),
          docenteNombre: `${docenteInfo.Nombre} ${docenteInfo.ApellidoPaterno} ${docenteInfo.ApellidoMaterno}`,
          trimestre,
          fase,
          alumnos: payload
        })
      });

      if (result.success) {
        // Mostrar mensaje de éxito con la misma animación que registrar-alumnos
        await Swal.fire({
          icon: 'success',
          title: 'Registrado',
          text: `Calificaciones guardadas correctamente. Total alumnos procesados: ${result.totalAlumnos}`,
          showConfirmButton: false,
          timer: 2500
        });

        // Limpiar formulario y recargar trimestres disponibles
        setNotas({});
        setAsistData({});
        setTrimestre(''); // Limpiar trimestre seleccionado
        
        // Recargar trimestres disponibles para actualizar la lista
        if (grupo) {
          await cargarTrimestresDisponibles(grupo);
        }
        
      } else {
        throw new Error(result.error || 'Error desconocido al guardar');
      }

    } catch (error) {
      console.error('Error al guardar calificaciones:', error);
      await Swal.fire('Error', 'Error al guardar calificaciones: ' + error.message, 'error');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="bg-light min-vh-100">
      {/* Estilos inlined para replicar el <style> del HTML */}
      <style>{`
        body { font-family: Arial, sans-serif; }
        .card { border-radius: 14px; }
        .header-leng { background-color: #d0e4f7; }
        .header-cien { background-color: #d6eadf; }
        .header-etica { background-color: #f9e2c0; }
        .header-comun { background-color: #f5d0d0; }
        th, td { text-align: center; vertical-align: middle; }
        .rotated { writing-mode: vertical-rl; transform: rotate(180deg); font-size: 12px; }
      `}</style>

      <div className="container py-4">
        <h3 className="text-center mb-4">Registro de Calificaciones por Grupo</h3>

        {/* Filtros */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label htmlFor="cboGrupo" className="form-label">Grupo</label>
            <select
              id="cboGrupo"
              className="form-select"
              value={grupo}
              onChange={(e) => handleGrupoChange(e.target.value)}
              disabled={loading}
            >
              <option value="" disabled>
                {loading ? 'Cargando grupos...' : 'Selecciona un grupo...'}
              </option>
              {gruposDisponibles.map((g) => (
                <option key={g.IdGrupo} value={g.IdGrupo}>
                  {g.GrupoDisplay}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="cboTrimestre" className="form-label">Trimestre</label>
            <select
              id="cboTrimestre"
              className="form-select"
              value={trimestre}
              onChange={(e) => handleTrimestreChange(e.target.value)}
              disabled={!grupo || trimestresDisponibles.length === 0}
            >
              <option value="" disabled>
                {!grupo ? 'Selecciona un grupo primero...' : 
                 trimestresDisponibles.length === 0 ? 'No hay trimestres disponibles' : 
                 'Selecciona...'}
              </option>
              {trimestresDisponibles.map((trimestre) => (
                <option key={trimestre.valor} value={trimestre.valor}>
                  {trimestre.nombre} ({trimestre.pendientes} alumnos pendientes)
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="txtFase" className="form-label">Fase</label>
            <input type="text" id="txtFase" className="form-control" value={fase} readOnly disabled />
          </div>
        </div>

        {/* Tabla de calificaciones */}
        <div className="card shadow-sm">
          <div className="card-body table-responsive">
            <table className="table table-bordered table-sm" id="tablaRegistro">
              <thead>
                <tr>
                  <th rowSpan={2}>No</th>
                  <th rowSpan={2} style={{ minWidth: 200 }}>NOMBRE DEL ALUMNO</th>

                  {/* Categorías de materias dinámicas */}
                  {categoriasYMaterias.map(categoria => {
                    // Determinar clase de color según el nombre de la categoría
                    let colorClass = 'header-categoria';
                    const nombreCategoria = categoria.CategoriaMateria.toLowerCase();
                    
                    if (nombreCategoria.includes('lenguaje') || nombreCategoria.includes('comunicacion')) {
                      colorClass += ' bg-lenguajes';
                    } else if (nombreCategoria.includes('saberes') || nombreCategoria.includes('ciencia') || nombreCategoria.includes('cientifica')) {
                      colorClass += ' bg-saberes';
                    } else if (nombreCategoria.includes('matematica') || nombreCategoria.includes('pensamiento')) {
                      colorClass += ' bg-matematicas';
                    } else if (nombreCategoria.includes('etica') || nombreCategoria.includes('civica') || nombreCategoria.includes('social')) {
                      colorClass += ' bg-etica';
                    } else if (nombreCategoria.includes('artes') || nombreCategoria.includes('arte')) {
                      colorClass += ' bg-artes';
                    } else if (nombreCategoria.includes('educacion') || nombreCategoria.includes('fisica')) {
                      colorClass += ' bg-educacion-fisica';
                    } else {
                      colorClass += ' bg-default';
                    }

                    return (
                      <th key={categoria.IdCategoriaMateria} colSpan={categoria.materias.length} className={colorClass}>
                        {categoria.CategoriaMateria.toUpperCase()}
                      </th>
                    );
                  })}

                  <th rowSpan={2}>ASISTENCIAS</th>
                  <th rowSpan={2}>INASISTENCIAS</th>
                  <th rowSpan={2}>SUGERENCIAS</th>
                  <th rowSpan={2}>OBSERVACIONES</th>
                </tr>
                <tr>
                  {/* Materias específicas por categoría */}
                  {categoriasYMaterias.map(categoria => (
                    categoria.materias.map((materia, index) => (
                      <th key={`${categoria.IdCategoriaMateria}-${materia.IdMateria}`} className="rotated">
                        {materia.NombreMateria.toUpperCase()}
                      </th>
                    ))
                  )).flat()}
                </tr>
              </thead>

              <tbody>
                {(() => {
                  // Calcular total de columnas dinámicamente
                  const totalColumnas = 2 + // No + Nombre
                    categoriasYMaterias.reduce((sum, cat) => sum + cat.materias.length, 0) + // Solo materias
                    4; // Asistencias + Inasistencias + Sugerencias + Observaciones

                  if (loading) {
                    return (
                      <tr>
                        <td colSpan={totalColumnas} className="text-center">
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                        Cargando…
                      </td>
                    </tr>
                    );
                  }

                  if (!grupo) {
                    return (
                      <tr>
                        <td colSpan={totalColumnas} className="text-muted">
                          Selecciona un grupo para registrar calificaciones…
                        </td>
                      </tr>
                    );
                  }

                  if (!trimestre) {
                    return (
                      <tr>
                        <td colSpan={totalColumnas} className="text-muted">
                          Selecciona un trimestre para registrar calificaciones…
                        </td>
                      </tr>
                    );
                  }

                  if (alumnos.length === 0) {
                    return (
                      <tr>
                        <td colSpan={totalColumnas} className="text-muted">
                          No hay alumnos en este grupo.
                        </td>
                      </tr>
                    );
                  }

                  if (categoriasYMaterias.length === 0) {
                    return (
                      <tr>
                        <td colSpan={totalColumnas} className="text-muted">
                          No tienes materias asignadas en este grupo.
                        </td>
                      </tr>
                    );
                  }

                  return alumnos.map((alumno, idx) => {
                    const asist = asistData?.[idx]?.asist ?? "";
                    const inas = asistData?.[idx]?.inas ?? "";
                    const sugerencias = asistData?.[idx]?.sugerencias ?? "";
                    const observaciones = asistData?.[idx]?.observaciones ?? "";

                    return (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td className="text-start">{alumno.NombreCompleto}</td>

                        {/* Materias dinámicas por categoría */}
                        {categoriasYMaterias.map(categoria => {
                          const materiasJSX = categoria.materias.map(materia => {
                            const key = `cat-${categoria.IdCategoriaMateria}-mat-${materia.IdMateria}`;
                            const nota = notas?.[idx]?.[key] ?? "";

                            return (
                              <td key={key}>
                                <select
                                  className="nota form-select form-select-sm"
                                  value={nota}
                                  onChange={(e) => handleNotaChange(idx, key, e.target.value)}
                                >
                                  <option value="">--</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                </select>
                              </td>
                            );
                          });

                          return materiasJSX;
                        }).flat()}

                        <td>
                          <input
                            type="number"
                            min="0"
                            className="form-control form-control-sm"
                            value={asist}
                            onChange={(e) =>
                              setAsistData((prev) => ({
                                ...prev,
                                [idx]: { ...(prev[idx] || {}), asist: e.target.value },
                              }))
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            min="0"
                            className="form-control form-control-sm"
                            value={inas}
                            onChange={(e) =>
                              setAsistData((prev) => ({
                                ...prev,
                                [idx]: { ...(prev[idx] || {}), inas: e.target.value },
                              }))
                            }
                          />
                        </td>
                        <td>
                          <textarea
                            className="form-control form-control-sm"
                            rows="2"
                            placeholder="Sugerencias..."
                            value={sugerencias}
                            onChange={(e) =>
                              setAsistData((prev) => ({
                                ...prev,
                                [idx]: { ...(prev[idx] || {}), sugerencias: e.target.value },
                              }))
                            }
                          />
                        </td>

                        {/* Observaciones */}
                        <td>
                          <textarea
                            className="form-control form-control-sm"
                            rows="2"
                            placeholder="Observaciones..."
                            value={observaciones}
                            onChange={(e) =>
                              setAsistData((prev) => ({
                                ...prev,
                                [idx]: { ...(prev[idx] || {}), observaciones: e.target.value },
                              }))
                            }
                          />
                        </td>
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-3 text-center">
          <button 
            className="btn btn-success" 
            id="btnGuardar" 
            onClick={handleGuardar}
            disabled={guardando}
          >
            {guardando ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Guardando...
              </>
            ) : (
              'Guardar Calificaciones'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistroCalificacionesGrupo;
